import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { CaptionComponent, CaptionComponentProps } from "../CaptionComponent";

export type CaptionProps = Pick<CaptionComponentProps, "required" | "htmlFor" | "alwaysShowCaption"> & {
    /** Lokalizační klíč pro caption. */
    locKey: string;
};

type StateProps = Pick<CaptionComponentProps, "text" | "title">;

const mapStateToProps: MapStateToProps<StateProps, CaptionProps, IAppState> = (state, { locKey }) => ({
    text: getPrimaryText(state, locKey),
    title: getSecondaryText(state, locKey),
});

export const Caption = connect(mapStateToProps)(CaptionComponent);
